module.exports = __webpack_public_path__ + "static/media/science5.bc45dc29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/img/science5.jpg
// module id = 586
// module chunks = 0